'use client';

import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

export function SpotlightAnalyticsTracker() {
  const { skuImpressionId, skuViewedPayload } = useAnalyticsSkuViewedContext();
  const entitySection = skuViewedPayload?.impression_section || 'roundup_recommendations';
  const impressionPosition = skuViewedPayload?.impression_position;
  const activityId = useRef(uuid()).current;

  if (impressionPosition === undefined) {
    return null;
  }

  return (
    <FeatureViewed
      activityId={activityId}
      additionalAttributes={{
        sku_impression_id: skuImpressionId,
        sku_id: skuViewedPayload?.sku_id,
      }}
      entityName="offer_spotlight"
      entitySection={entitySection}
      impressionPosition={impressionPosition}
    >
      <div style={{ visibility: 'hidden' }} />
    </FeatureViewed>
  );
}
